import React from 'react';
import { Button } from '../ui';

/** @deprecated Use `<Button />` from `../ui`. */
const ThemePrimaryButton = React.forwardRef(function ThemePrimaryButton(props, ref) {
  return <Button ref={ref} variant="default" {...props} />;
});

export default ThemePrimaryButton;
